import React from "react"

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useHookstate } from "@hookstate/core";

import { mostraCpfOuCnpjFormatado } from "@refere/ui-utils/ui/utils/format";

import globalState from "../../../features/global-state";
import magCapitalizacaoImg from "../../../images/mag-capitalizacao.png"

const Header = () => {
    const headerState = useHookstate(globalState.simulacaoState.header);

    const isCpf = headerState.tipoPessoa.get() == 0;

    return(
        headerState.get() &&
        <Paper
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                mb: 1
            }}
        >
            <Box>
                <Typography>Nome do Titular: {headerState.nome.get()}</Typography>
                <Typography>{isCpf ? "CPF" : "CNPJ"}: {mostraCpfOuCnpjFormatado(headerState.cpfCnpj.get())}</Typography>
                <Typography>Cotação: {headerState.idSimulacao.get()}</Typography>
            </Box>
            <Box>
                <img 
                    width="130px" 
                    src={magCapitalizacaoImg}
                />                                  
            </Box>
        </Paper>
    )
}

export default Header